import { z } from "zod";

// Schemas

export const ExampleFileSchema = z.object({
  fileName: z.string(),
  fileBits: z.string(),
  fileType: z.string(),
});
